/**
 * Platform detection — evaluated once at module load.
 * Uses the modern User-Agent Client Hints API with legacy fallback.
 */
export const IS_MAC =
  navigator.userAgentData?.platform === 'macOS' ||
  /mac/i.test(navigator.platform)

/** Modifier key label for keyboard shortcut hints. */
export const MOD_KEY = IS_MAC ? '⌘' : 'Ctrl'
